import { render, staticRenderFns } from "./ModalTipoTurno.vue?vue&type=template&id=ccdc5e1e&scoped=true"
import script from "./ModalTipoTurno.vue?vue&type=script&lang=js"
export * from "./ModalTipoTurno.vue?vue&type=script&lang=js"
import style0 from "./ModalTipoTurno.vue?vue&type=style&index=0&id=ccdc5e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdc5e1e",
  null
  
)

export default component.exports